import { ChangeDetectionStrategy, Component, computed, HostListener, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieConsentService } from './services/cookie-consent.service';

@Component({
  selector: 'app-cookies',
  imports: [TranslateModule, RouterModule],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiesComponent {
  private readonly cookiesService = inject(CookieConsentService);
  private readonly router = inject(Router);

  @HostListener('document:keydown.escape')
  public onEscape() {
    if (this.visible()) {
      this.cookiesService.dismissBannerTemporarily();
    }
  }

  protected readonly visible = computed(() => this.cookiesService.shouldShowBanner());

  public acceptAll() {
    this.cookiesService.setAll(true);
  }
  public rejectAll() {
    this.cookiesService.setAll(false);
  }

  public async configure() {
    this.cookiesService.dismissBannerTemporarily();
    await this.router.navigateByUrl('/policies/cookies-settings');
  }
}
